<template>
    <tab-layout :buttons="buttons" :permissions="permissions">
        <template #title>
            {{ $l10n.__('Paniers') }}
        </template>

        <template #content>
            <CompassAlert
                v-if="shouldDisplayGoToBubbleAlert"
                :description="
                    $t.__('overview.tabs.TabSamCartsList.only_cart_created_with_SAM_available')
                "
                :action="{
                    label: $t.__('overview.tabs.TabSamCartsList.see_cart_created_with_chargebee'),
                    callback: () => goToBubbleCarts(),
                }"
                :show-close="false"
            />

            <div class="prelative mt-3" v-if="loading">
                <preloader :display="loading" />
            </div>
            <div class="flex-column" v-if="!loading">
                <sam-cart-items-list
                    :corporation="corporation"
                    :carts="carts"
                    :products="products"
                    :permissions="permissions"
                />
            </div>
        </template>
    </tab-layout>
</template>

<script>
import OverviewTabMixin from './OverviewTabMixin';
import { buildUrl, getRouteByName, buildRoute, goToUrl } from '../../../helpers';
import CartItemsList from '../../sellsyaccountmanager/CartItemsList.vue';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';
import SellsyAccountManagerRoutes from 'routes/sellsyaccountmanager';
import Env from 'Services/Env';

export default {
    components: {
        'sam-cart-items-list': CartItemsList,
        Preloader,
        TabLayout,
    },
    mixins: [OverviewTabMixin],
    props: {
        more: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            carts: [],
            products: [],
            permissions: {},
            loading: true,
        };
    },
    computed: {
        isChargebeProvider() {
            return this.$store.getters.customer?.billingSettings?.billingProvider === 'chargebee';
        },
        buttons() {
            if (this.isChargebeProvider) {
                return [];
            }
            return this.more.buttons;
        },
        parameters() {
            return [
                {
                    key: 'corpid',
                    value: this.corporation,
                },
            ];
        },
        route() {
            return buildUrl(this.more.url, this.parameters);
        },
        corporation() {
            return this.$store.getters.dataFetch.sellsyadmin.id;
        },
        shouldDisplayGoToBubbleAlert() {
            return (
                this.isChargebeProvider &&
                this.$store.getters.customer?.billingSettings?.chargebeeCustomerId
            );
        },
    },
    created() {
        EventBus.on('sam:cart:create', (payload) => {
            this.goToUrl(this.buildCartFormUrl(this.corporation));
        });

        this.fetch();
    },
    methods: {
        goToBubbleCarts() {
            const url = `${Env.get('chargebee').bubbleUrl}/customer_details?customer_id=${
                this.$store.getters.customer?.billingSettings?.chargebeeCustomerId
            }&page=quote_list`;
            window.open(url, '_blank');
        },
        fetch() {
            this.loading = true;
            this.$ajax.get(this.route, {}, (response) => {
                this.carts = response.carts;
                this.products = response.products;
                this.permissions = response.permissions;
                this.loading = false;
            });
        },
        buildCartFormUrl(corporation) {
            const route = SellsyAccountManagerRoutes.find((route) => route.name == 'sam.cart.form');
            if (this.$store.getters.customer.billingSettings.pricingVersion === 4) {
                if (this.$store.getters.customer.levelReadable === 'gold') {
                    return this.$router.resolve({
                        name: 'sam.v4.upsell.cart.form',
                        params: {
                            corpId: corporation,
                            thirdId: this.$store.getters.customer.saasThirdId,
                            customerId: this.$store.getters.customer.id,
                            id: 'new',
                        },
                    }).href;
                } else {
                    return this.$router.resolve({
                        name: 'sam.v4.cart.form',
                        params: {
                            thirdId: this.$store.getters.customer.saasThirdId,
                            customerId: this.$store.getters.customer.id,
                            id: 'new',
                        },
                    }).href;
                }
            } else {
                return this.buildRoute(route, [{ key: 'id', value: corporation }]);
            }
        },
        buildUrl,
        getRouteByName,
        goToUrl,
        buildRoute,
    },
};
</script>
